import { Component, Node, _decorator } from 'cc';
import Page from '../../../../common/scripts/Toolkit/Components/Page/Page';

const { ccclass, requireComponent } = _decorator;

@ccclass('MouseWheelPageCloser')
@requireComponent(Page)
export default class MouseWheelPageCloser extends Component {
    private _page: Page = null;

    private get page() {
        if (!this._page) {
            this._page = this.getComponent(Page);
        }
        return this._page;
    }

    protected onLoad() {
        this.page.mask.on(Node.EventType.MOUSE_WHEEL, this._onMouseWheel, this);
    }

    protected onDestroy() {
        this.page.mask.off(Node.EventType.MOUSE_WHEEL, this._onMouseWheel, this);
    }

    private _onMouseWheel() {
        this.page.close();
    }
}
